import React from 'react';
import CategoryRow from './CategoryRow';
import Pagination from '../../Pagination';
import s from './categories.module.css';

// The categories table and its footer. Sorting is indicated on the Name header
// only, which is the column MMS marks.

export default function CategoryTable({
  rows, total, sort, openMenuId, onToggleMenu, onEdit, onDelete,
  page, pageCount, perPage, onPageChange, onPerPageChange,
}) {
  const arrow = (key) => (sort.key === key ? (sort.desc ? ' ↑' : ' ↓') : '');

  return (
    <div className={s.wrap}>
      <table className={s.table}>
        <thead>
          <tr>
            <th>Name{arrow('label')}</th>
            <th>Type{arrow('type')}</th>
            <th className={s.right}>Transactions{arrow('count')}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td className={s.emptyCell} colSpan={4}>No categories yet.</td>
            </tr>
          ) : rows.map((c) => (
            <CategoryRow
              key={c.id}
              category={c}
              menuOpen={openMenuId === c.id}
              onToggleMenu={onToggleMenu}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </tbody>
      </table>

      <Pagination
        page={page}
        pageCount={pageCount}
        perPage={perPage}
        total={total}
        onPageChange={onPageChange}
        onPerPageChange={onPerPageChange}
      />
    </div>
  );
}
